import email from "@/assets/icons/email.svg";
import headset from "@/assets/icons/headset.svg";
import store from "@/assets/icons/store.svg";
import instore from "@/assets/icons/instore.svg";
import online from "@/assets/icons/online.svg";

const getIconSVG = iconName => {
  switch (iconName) {
    case "email":
      return email;
    case "headset":
      return headset;
    case "store":
      return store;
    case "instore":
      return instore;
    case "online":
      return online;
    default:
      return null;
  }
};

export default getIconSVG;
